var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"font-weight-bold grey--text text--darken-1"},[_vm._v(_vm._s(_vm.rotulo))]),_vm._t("default",function(){return [_c('div',{staticClass:"text-body-1"},[_vm._v(_vm._s(_vm.valor || "Não informado"))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }